'use client'

// src/util/minify.ts
var minifyGqlQuery = (query) => {
  return query.replace(/#.*\n/g, "").replace(/\s+/g, " ").replace(/\s*([{}():=@$.,])\s*/g, "$1").trim();
};

export {
  minifyGqlQuery
};
//# sourceMappingURL=chunk-SQE4KWHX.mjs.map